const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-100">
      <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
    </div>
  );
};

export default LoadingSpinner;